
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.082 25S0 25 0 22.918c0-2.086 2.082-8.336 12.5-8.336S25 20.832 25 22.918C25 25 22.918 25 22.918 25zM12.5 12.5a6.25 6.25 0 000-12.5 6.25 6.25 0 000 12.5zm0 0","fill":"#7a7d88"}})])
          )
        }
      }
    